import React, { useState } from "react";
import "../styles/MyReviewsPage.css"; // ✅ 새로운 스타일 적용
import MyPageEmpty from "./MyPageEmpty";
import MyReviewCard from "./MyReviewCard"; // ✅ 기존 카드 재사용

const MyReviewsSection = ({ myReviews }) => {
    // ✅ 페이지네이션 (최초 5개 표시)
    const [visibleReviews, setVisibleReviews] = useState(5);

    const loadMoreReviews = () => {
        setVisibleReviews(prev => prev + 5);
    };

    if (myReviews === "noData"){
        return <MyPageEmpty text="작성한 리뷰가 없습니다." />;
    }

    return (
        <div className="my-reviews-section">
            {/* 데이터가 없을 경우 */}
            {myReviews.length === 0 ? (
                <MyPageEmpty />
            ) : (
                <>
                    <div className="my-reviews-list">
                        {myReviews.slice(0, visibleReviews).map(item => (
                            <MyReviewCard key={item.id} orderItem={item} />
                        ))}
                    </div>

                    {/* ✅ 더보기 버튼 */}
                    {myReviews.length > visibleReviews && (
                        <button className="my-reviews-load-more-btn" onClick={loadMoreReviews}>
                            더보기 +
                        </button>
                    )}
                </>
            )}
        </div>
    );
};

export default MyReviewsSection;
